// 应用常量
export const APP_NAMES = {
  SUPPORT_CENTER: "support-center",
  ADMIN_PORTAL: "admin-portal",
  CLIENT_PORTAL: "client-portal",
  IB_PORTAL: "ib-portal",
} as const;

// 用户角色
export const USER_ROLES = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  USER: "user",
  IB_AGENT: "ib_agent",
} as const;

// 存储键名
export const STORAGE_KEYS = {
  TOKEN: "token",
  USER_INFO: "userInfo",
  THEME: "theme",
  LANGUAGE: "language",
} as const;

// API状态码
export const API_CODES = {
  SUCCESS: 200,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
} as const;

// 分页默认值
export const PAGINATION_DEFAULTS = {
  PAGE: 1,
  PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 100,
} as const;

// 主题色配置
export const THEME_COLORS = {
  SUPPORT_CENTER: "#1890ff",
  ADMIN_PORTAL: "#52c41a",
  CLIENT_PORTAL: "#722ed1",
  IB_PORTAL: "#fa8c16",
} as const;

// 文件上传限制
export const UPLOAD_LIMITS = {
  MAX_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_TYPES: ["image/jpeg", "image/png", "image/gif", "application/pdf"],
  ALLOWED_EXTENSIONS: [".jpg", ".jpeg", ".png", ".gif", ".pdf"],
} as const;
